module.exports = __webpack_public_path__ + "images/marketing/careers-sidebar-images.png";